import React                   from 'react';
import { connect }             from 'react-redux';
import { Dispatch }            from "redux";

import AppsGrid                from './apps_grid';
import AppPage                 from './app_page';
import About                   from './about';
import ScorePage               from './score_page';

import NavBar                  from '../components/navbar';
import SmallNavBar             from '../components/small_navbar';
import TopBar                  from '../components/topbar';
import CodeInput               from '../components/code_input';
import Loader                  from '../components/Loader';
import TeacherErrorModal       from '../components/TeacherErrorModal';

import setSubmitionNumbers     from '../utils/functions/setSubmitionNumbers'
import { words }               from '../utils/dictionary'
import { results }             from '../utils/functions/getStudentScores'

import {
         appsType,
         scoreType,
         userStateType,
         studentInfoType
       }                       from '../types'

import {
         RECORD_ENTRY_SAGA,
         GET_APPS_SAGA,
         GET_USER_INFO_SAGA,
         SUBMIT_CODE_SAGA,
         HIDE_TEACHER_ERROR,
         LOG_OUT_SAGA
       }                       from '../actions';

import { ActionTypes,
         submitCodeType
       }                       from '../actions/types';
import { reducerType }         from '../reducer';

import { makeStyles }          from '@material-ui/core/styles';

const pages = ['teacherCode', 'about', 'classes', 'pisa_questions']

const useStyles = makeStyles(() => ({
    root: {
        minHeight:       '100vh',
        minWidth:        '100vw',
        maxHeight:       '100vh',
        maxWidth:        '100vw',
        backgroundColor: '#FFF',
        overflowX:       'hidden',
        overflowY:       'hidden',
        transition:      'opacity 0.8s'
    },
    title: {
      position:        'fixed',
      left:            0,
      height:          100,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      textAlign:       'center',
      backgroundColor: '#FFF',
      fontSize:        28,
      transition:      'all 0.7s'
    },
    LoaderPage: {
      position:        'fixed',
      top:             0,
      left:            0,
      minHeight:       '100vh',
      minWidth:        '100vw',
      maxHeight:       '100vh',
      maxWidth:        '100vw',
      backgroundColor: '#FFF',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      textAlign:       'center',
      flexFlow:        'column',
    },
    loading: {
      fontWeight:  'bold',
      fontSize:     27,
      marginBottom: 40
    },
    submitButton: {
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      textAlign:       'center',
      position:        'absolute',
      left:            '50%',
      marginTop:       20,
      transform:       'translate(-50%, 0%)',
      width:           250,
      height:          50,
      backgroundColor: '#66C',
      color:           '#FFF',
      cursor:          'pointer',
      borderRadius:    '0.5em',
      boxShadow:       '0px 3px 10px 3px rgba(0,0,0,0.25)',
      '&:hover': {
          backgroundColor: '#55B',
      }
    }
}))


type RootProps = {
  userLogedIn:      string;
  userName:         string;
  userEmail:        string;
  userRole:         string;
  teacherId:        number;
  badTeacherError:  boolean;
  studentsInfo:     studentInfoType[];
  appsArray:        appsType[];
  submitCode:       (payload: submitCodeType) => void;
  recordEntry:      (payload: { [key:string]: string; }) => void;
  getApps:          () => void;
  getUserInfo:      () => void;
  hideTeacherError: () => void;
  logOut:           () => void;
}

const Root: React.FC<RootProps> = ({
  userLogedIn,
  userName,
  userEmail,
  userRole,
  teacherId,
  badTeacherError,
  studentsInfo,
  appsArray,
  getUserInfo,
  recordEntry, 
  submitCode,
  getApps,
  hideTeacherError,
  logOut
}) => {

  const classes = useStyles();

  const [size, setSize] = React.useState([0,0]);

  React.useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);


  const [userState, setUserState]                   = React.useState({} as userStateType)
  const [page, setPage]                             = React.useState('about')
  const [lang, setLang]                             = React.useState('heb')
  const [src, setSrc]                               = React.useState('')
  const [pageOpacity, setPageOpacity]               = React.useState(0);
  const [selectedApp, setSelectedApp]               = React.useState(0)
  const [selectedGrid, setSelectedGrid]             = React.useState(1)
  const [showSmallNavBar, setShowSmallNavBar]       = React.useState(false)
  const [initialPos, setInitialPos]                 = React.useState(false)
  const [showCodeInput, setShowCodeInput]           = React.useState(false)
  const [showCodeErrorModal, setShowCodeErrorModal] = React.useState(false)
  const [code, setCode]                             = React.useState('')
  const [appScoreName, setAppScoreName]             = React.useState([] as string[])
  const [scores, setScores]                         = React.useState([] as scoreType[][])
  const [selectedAppScore, setSelectedAppScore]     = React.useState([] as scoreType[])
  const [appsArr, setAppsArr]                       = React.useState(appsArray)

  React.useEffect(() => {
    getUserInfo();
  },[getUserInfo])

  React.useEffect(() => {
    getApps();
  },[getApps])


  React.useEffect(() => {
    setUserState({
      userName:  userName,
      userEmail: userEmail,
      teacherId: teacherId,
      userRole:  userRole
    })
  },[userName, userEmail, teacherId, userRole])


  React.useEffect(() => {

    const res = results(studentsInfo)
    const newAppsArr = setSubmitionNumbers(res, appsArray);

    setScores(res)
    setAppsArr(newAppsArr)

  },[studentsInfo, appsArray])


  React.useEffect(() => {
    if (localStorage.getItem('lang') && localStorage.getItem('lang') === 'arab') {
      setLang('arab')
    }
  },[])

  React.useEffect(() => {
    setTimeout(() => { setInitialPos(true) },10)
  },[])


  React.useEffect(() => {
    if (badTeacherError) {
      setShowCodeErrorModal(true)
    }
  },[badTeacherError])


  const [wideScreen, navbarSize] = React.useMemo(() => {
    return [size[0] > 600, size[0] > 900 ? 250 : 150]
  },[size])


  React.useEffect(() => {
    setTimeout(() => {
      setPageOpacity(1)
    },10)
  },[])


  React.useEffect(() => {
    if (wideScreen || !showSmallNavBar) {
      setShowSmallNavBar(false)
    }
  },[wideScreen, showSmallNavBar])



  const goToPage = (val: string) => {
    setPageOpacity(0)
    setTimeout(() => {
      setPage(val)
      setPageOpacity(1)
    },800)
  }

  const handleNavBarClick = (val: string) => {
    if (val === 'teacherCode') {
      setShowCodeInput(!showCodeInput)
    }
    else {
      if (showCodeInput) {
        setShowCodeInput(false)
      }
      setPageOpacity(0)
      setTimeout(() => {
        if (selectedAppScore.length && val !== 'studentResults') {
          setSelectedAppScore([])
        }
        setPage(val)
        setPageOpacity(1)
      },800)
    }
  }

  const handleAppClick = (val: number) => {
    
    const payload = {
      app:       lang === 'heb' ? (!!appsArr[val].lesson_id ? `${appsArr[val].lesson_id}` : '') : (!!appsArr[val].arabic ? `${appsArr[val].arabic}` : ''),
      userName:  userName,
      userEmail: userEmail,
      userRole:  userRole
    }

     recordEntry(payload);
     setSelectedApp(val)
     setSelectedGrid(appsArr[val].classes)
     setSrc(`https://www.yisumatica.org.il/flash-upload/js/js.html?n=242&lang=${ lang === 'heb' ? 'he' : 'ar' }&page=${ (lang === 'heb' || !appsArr[val].arabic ) ? appsArr[val].lesson_id : appsArr[val].arabic }&exit_button=1&piza=1&mail=${ userState.userEmail }&name_heb=${ userState.userName }&teacher_id=${ userState.teacherId <= 0 ? '-1' : `${ userState.teacherId }` }`)
     goToPage('app_page')
  }

  const goToAppGrid = () => {
    goToPage(selectedGrid === 1 ? 'classes': 'pisa_questions')
  }


  const handleSubmitCode = () => {
    if (+code === teacherId) {
      return
    }
    const payload = {
      userEmail: userEmail,
      code: +code
    }
    submitCode(payload)
  }


  const handleStudentInfoClick = (arr: string[]) => {

     const [id, app, appArabic] = arr;

     for (let i = 0; i < scores.length; i++) {
        if (scores[i][0].lessontype === id) {
          setSelectedAppScore(scores[i]);
          break;
        }
     }
     setAppScoreName([app, appArabic])
     handleNavBarClick('studentResults')
  }


  const handleErrorModalClick = () => {
    setShowCodeErrorModal(false)
    hideTeacherError()
  }

  const titleStyle = React.useMemo(() => {
    return {
      width: wideScreen ? size[0] - navbarSize : '100vw',
      top:   initialPos ? 100 : -200,
    }
  },[size, navbarSize, wideScreen, initialPos])



/* 
  const appsrc = React.useMemo(() => {
    if ( !selectedApp ) { return "" }
    if ( !appsArr )     { return "" }
    if ( !appsArr[selectedApp] || !appsArr[selectedApp].lesson_id )   { return "" }
    return `https://www.yisumatica.org.il/flash-upload/js/js.html?n=242&lang=${ lang === 'heb' ? 'he' : 'ar' }&page=${ (lang === 'heb' || !appsArr[selectedApp].arabic ) ? appsArr[selectedApp].lesson_id : appsArr[selectedApp].arabic }&exit_button=1&piza=1&mail=${ userState.userEmail }&name_heb=${ userState.userName }&teacher_id=${ userState.teacherId <= 0 ? '-1' : `${ userState.teacherId }` }`
  },[lang,appsArr,selectedApp,userState ]) */


  console.log('* * * * * * * * * * * * * * * * * * * * * * * * ',)
  console.log('* * * * * * * * * * * * * * * * * * * * * * * * ',)
  console.log('src : ',src)
  console.log('* * * * * * * * * * * * * * * * * * * * * * * * ',)
  console.log('* * * * * * * * * * * * * * * * * * * * * * * * ',)

  //https://www.yisumatica.org.il/flash-upload/js/js.html?lang=he&page=Link_document&n=242
  return (
    <>
        <div
          className = { classes.root }
          style     = {{
            opacity: pageOpacity
          }}
        >
          {
            page !== 'app_page'
            &&
            <div
              className = { classes.title }
              dir       = 'rtl'
              style     = { titleStyle }
            >
                { `${ words[`${ page }`][lang] } ${ page === 'studentResults' ? ` - ${ lang === 'heb' ? appScoreName[0] : appScoreName[1] }` : '' }` }
            </div>
          }
          {
              page === 'studentResults'
              &&
              <ScorePage
                  size         = { size }
                  wideScreen   = { wideScreen }
                  navbarSize   = { navbarSize }
                  lang         = { lang }
                  scores       = { selectedAppScore }
              />
          }
          {
              page === 'pisa_questions'
              &&
              <AppsGrid
                  size                   = { size }
                  wideScreen             = { wideScreen }
                  navbarSize             = { navbarSize }
                  lang                   = { lang }
                  userRole               = { userRole }
                  appsArr                = { appsArr }
                  variant                = { '2' }
                  handleAppClick         = { handleAppClick }
                  handleStudentInfoClick = { handleStudentInfoClick }
              />
          }
          {
              page === 'classes'
              &&
              <AppsGrid
                  size                   = { size }
                  wideScreen             = { wideScreen }
                  navbarSize             = { navbarSize }
                  lang                   = { lang }
                  userRole               = { userRole }
                  appsArr                = { appsArr }
                  variant                = { '1' }
                  handleAppClick         = { handleAppClick }
                  handleStudentInfoClick = { handleStudentInfoClick }
              />
          }
          {
            page === 'about'
            &&
            <About
                size       = { size }
                navbarSize = { navbarSize }
                wideScreen = { wideScreen }
                lang       = { lang }
            />
          }
          {
            page === 'app_page'
            &&
            <AppPage
               src         = { src }
               goToAppGrid = { goToAppGrid }
            />
          }
        </div>
        {
            page !== 'app_page'
            &&
            <>
              {
                wideScreen
                &&
                <NavBar
                    pages             = { pages }
                    size              = { size }
                    navbarSize        = { navbarSize }
                    page              = { page }
                    lang              = { lang }
                    showSmallNavBar   = { showSmallNavBar }
                    handleNavBarClick = { handleNavBarClick }
                />
              }
              <SmallNavBar
                  pages              = { pages }
                  size               = { size }
                  page               = { page }
                  lang               = { lang }
                  showSmallNavBar    = { showSmallNavBar }
                  logOut             = { logOut }
                  setLang            = { setLang }
                  handleNavBarClick  = { handleNavBarClick }
                  setShowSmallNavBar = { setShowSmallNavBar }
              />
              <TopBar
                    size               = { size }
                    navbarSize         = { navbarSize }
                    lang               = { lang }
                    page               = { page }
                    wideScreen         = { wideScreen }
                    showSmallNavBar    = { showSmallNavBar }
                    logOut             = { logOut }
                    setLang            = { setLang }
                    setPage            = { setPage }
                    setPageOpacity     = { setPageOpacity }
                    setShowSmallNavBar = { setShowSmallNavBar }
              />
              <CodeInput
                 size               = { size }
                 navbarSize         = { navbarSize }
                 wideScreen         = { wideScreen }
                 lang               = { lang }
                 showCodeInput      = { showCodeInput }
                 showSmallNavBar    = { showSmallNavBar }
                 code               = { code }
                 userRole           = { userRole }
                 teacherId          = { teacherId }
                 setCode            = { setCode }
                 handleSubmitCode   = { handleSubmitCode }
                 setShowCodeInput   = { setShowCodeInput }
                 setShowSmallNavBar = { setShowSmallNavBar }
              />
            </>
        }
        {
          <TeacherErrorModal
             showCodeErrorModal = { showCodeErrorModal }
             handleClick        = { handleErrorModalClick }
          />
        }
       {/*  {
          userLogedIn === ''
          &&
          <div className = { classes.LoaderPage }>
            <div className = { classes.loading } dir = 'rtl'>
               { words['loading'][lang] }
            </div>
            <Loader/>
          </div>
        }
        {
          userLogedIn === 'false'
          &&
          <div className = { classes.LoaderPage }>
            <a href = 'https://www.yisumatica.org.il/flash-upload/pisa-math-login/' dir = 'rtl'>
              <div  className = { classes.submitButton }>
                 { words['signIn'][lang] }
               </div>
            </a>
          </div>
        } */}
    </>
  );
}



const mapStateToProps = (reducer: reducerType) => {

  return {
    appsArray:       reducer.appsArray,
    userLogedIn:     reducer.userLogedIn,
    userName:        reducer.userName,
    userEmail:       reducer.userEmail,
    teacherId:       reducer.teacherId,
    userRole:        reducer.userRole,
    studentsInfo:    reducer.studentsInfo,
    badTeacherError: reducer.badTeacherError,
}};

const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
  getApps:          () => dispatch(GET_APPS_SAGA()),
  getUserInfo:      () => dispatch(GET_USER_INFO_SAGA()),
  hideTeacherError: () => dispatch(HIDE_TEACHER_ERROR()),
  logOut:           () => dispatch(LOG_OUT_SAGA()),
  submitCode:       (payload: submitCodeType) => dispatch(SUBMIT_CODE_SAGA(payload)),
  recordEntry:      (payload: { [key:string]: string; }) => dispatch(RECORD_ENTRY_SAGA(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Root);
